"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsState = exports.Tabs = exports.panelProps = exports.TabWrapper = exports.Tab = exports.TabBar = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _renderFragment = _interopRequireDefault(require("render-fragment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _placeholder = _interopRequireDefault(require("../placeholder/placeholder"));

var Wrapper =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e1lzzkxx0"
})(function (_ref) {
  var theme = _ref.theme,
      bordered = _ref.bordered;
  return bordered ? {
    overflow: 'hidden',
    background: theme.mainFill,
    borderRadius: theme.mainBorderRadius,
    border: theme.mainBorder
  } : {};
}, function (_ref2) {
  var absolute = _ref2.absolute;
  return absolute ? {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
  } : {
    display: 'block'
  };
});
var TabBar =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e1lzzkxx1"
})(function (_ref3) {
  var theme = _ref3.theme;
  return {
    background: theme.barFill,
    borderBottom: theme.mainBorder,
    overflow: 'auto',
    padding: '0 8px',
    whiteSpace: 'nowrap',
    height: 40
  };
});
exports.TabBar = TabBar;
var TabButton =
/*#__PURE__*/
(0, _styled.default)("button", {
  target: "e1lzzkxx2"
})({
  whiteSpace: 'normal',
  display: 'inline-flex',
  overflow: 'hidden',
  verticalAlign: 'top',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  '&:empty': {
    display: 'none'
  }
}, function (_ref4) {
  var theme = _ref4.theme;
  return {
    fontSize: 11,
    letterSpacing: '1px',
    padding: '0 8px',
    textTransform: 'uppercase',
    transition: 'color 0.2s linear, border-bottom-color 0.2s linear',
    height: 40,
    lineHeight: '12px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    background: 'transparent',
    border: '0 solid transparent',
    borderTop: '3px solid transparent',
    borderBottom: '3px solid transparent',
    '&:focus': {
      outline: '0 none',
      borderBottomColor: theme.highlightColor
    }
  };
}, function (_ref5) {
  var active = _ref5.active,
      theme = _ref5.theme;
  return active ? {
    color: theme.mainTextColor,
    borderBottomColor: theme.barSelectedColor
  } : {
    color: theme.dimmedTextColor,
    borderBottomColor: 'transparent'
  };
});
var Content =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e1lzzkxx3"
})({
  display: 'block',
  position: 'relative'
}, function (_ref6) {
  var absolute = _ref6.absolute;
  return absolute ? {
    position: 'relative',
    overflow: 'auto',
    flex: 1,
    width: '100%'
  } : {};
});

var Tab = function Tab(_ref7) {
  var active = _ref7.active,
      name = _ref7.name,
      title = _ref7.title,
      onSelect = _ref7.onSelect;

  var onClick = function onClick(e) {
    e.preventDefault();
    onSelect(name);
  };

  return _react.default.createElement(TabButton, {
    type: "button",
    key: name,
    active: active,
    onClick: onClick,
    role: "tab"
  }, typeof title === 'function' ? title() : title);
};

exports.Tab = Tab;
Tab.propTypes = {
  active: _propTypes.default.bool.isRequired,
  name: _propTypes.default.string.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]).isRequired,
  onSelect: _propTypes.default.func.isRequired
};
var VisuallyHidden =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e1lzzkxx4"
})(function (_ref8) {
  var active = _ref8.active;
  return active ? {
    display: 'block'
  } : {
    display: 'none'
  };
});

var TabWrapper = function TabWrapper(_ref9) {
  var active = _ref9.active,
      render = _ref9.render,
      children = _ref9.children;
  return _react.default.createElement(VisuallyHidden, {
    active: active
  }, render ? render() : children);
};

exports.TabWrapper = TabWrapper;
TabWrapper.propTypes = {
  active: _propTypes.default.bool.isRequired,
  render: _propTypes.default.func,
  children: _propTypes.default.node
};
TabWrapper.defaultProps = {
  render: undefined,
  children: undefined
};
var panelProps = {
  active: _propTypes.default.bool
};
exports.panelProps = panelProps;

var Tabs = function Tabs(_ref10) {
  var children = _ref10.children,
      selected = _ref10.selected,
      onSelect = _ref10.onSelect,
      absolute = _ref10.absolute,
      bordered = _ref10.bordered;

  var list = _react.default.Children.toArray(children).map(function (_ref11, index) {
    var _ref11$props = _ref11.props,
        title = _ref11$props.title,
        id = _ref11$props.id,
        childrenOfChild = _ref11$props.children;
    var content = Array.isArray(childrenOfChild) ? childrenOfChild[0] : childrenOfChild;
    return {
      active: selected ? id === selected : index === 0,
      title: title,
      id: id,
      render: typeof content === 'function' ? content : // eslint-disable-next-line react/prop-types
      function (_ref12) {
        var active = _ref12.active;
        return _react.default.createElement(VisuallyHidden, {
          active: active,
          role: "tabpanel"
        }, content);
      }
    };
  });

  return list.length ? _react.default.createElement(Wrapper, {
    absolute: absolute,
    bordered: bordered
  }, _react.default.createElement(TabBar, {
    role: "tablist"
  }, list.map(function (_ref13) {
    var title = _ref13.title,
        id = _ref13.id,
        active = _ref13.active;
    return _react.default.createElement(Tab, {
      key: "".concat(id, "-bar"),
      active: active,
      name: id,
      title: title,
      onSelect: onSelect
    });
  })), _react.default.createElement(Content, {
    absolute: absolute
  }, list.map(function (_ref14) {
    var id = _ref14.id,
        active = _ref14.active,
        render = _ref14.render;
    return _react.default.createElement(_renderFragment.default, {
      key: "".concat(id, "-panel")
    }, render({
      active: active,
      selected: selected
    }));
  }))) : _react.default.createElement(_placeholder.default, null, "no panels available");
};

exports.Tabs = Tabs;
Tabs.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  selected: _propTypes.default.string,
  onSelect: _propTypes.default.func.isRequired,
  absolute: _propTypes.default.bool.isRequired,
  bordered: _propTypes.default.bool.isRequired
};
Tabs.defaultProps = {
  children: [],
  selected: null
};

var TabsState =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TabsState, _Component);

  function TabsState(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabsState);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabsState).call(this, props));
    _this.state = {
      selected: props.initial
    };
    return _this;
  }

  (0, _createClass2.default)(TabsState, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          bordered = _this$props.bordered,
          absolute = _this$props.absolute,
          children = _this$props.children;
      var selected = this.state.selected;
      return _react.default.createElement(Tabs, {
        bordered: bordered || true,
        absolute: absolute || false,
        selected: selected,
        onSelect: function onSelect(id) {
          return _this2.setState({
            selected: id
          });
        }
      }, children);
    }
  }]);
  return TabsState;
}(_react.Component);

exports.TabsState = TabsState;
(0, _defineProperty2.default)(TabsState, "propTypes", {
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  initial: _propTypes.default.string,
  absolute: _propTypes.default.bool,
  bordered: _propTypes.default.bool
});
(0, _defineProperty2.default)(TabsState, "defaultProps", {
  children: [],
  initial: null,
  absolute: false,
  bordered: false
});